<template>
	<div class="height-100">
		<div class="text-end">
			<div
				v-if="text"
				class="bubble"
				:class="{
					'bubble-kids kids-bubble-bottom-right': gameMode === 'kids',
					'bubble-adults adults-bubble-bottom-right': gameMode === 'adults',
					'no-margin': !isMarginRequired,
					'bubble-kids-animate': playerTwoStatus && gameMode === 'kids',
					'bubble-adults-animate': playerTwoStatus && gameMode === 'adults',
				}"
			>
				<ElementHeadlineSmall class="bubble--text" content="Zeit" i18n v-if="showSubComponent" />
				<span v-if="timerStart"><Timer /></span>
				<span class="base-timer--label" v-if="showSubComponent && !timerStart">0:00</span>
				<ElementHeadlineSmall v-for="txt of text" class="bubble--text" :key="txt" :content="txt" i18n />
			</div>
		</div>
		<div :class="className"></div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import Timer from '../ui/Timer.vue';

export default {
	name: 'speachBubbleWithImageRight',
	components: {
		Timer,
	},
	props: {
		className: [String, Object],
		text: Array,
		isMarginRequired: Boolean,
		playerTwoStatus: Boolean,
		showSubComponent: Boolean,
		timerStart: Boolean,
	},
	computed: {
		...mapState(['gameMode']),
	},
};
</script>
